import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  TextField,
  MenuItem,
  Select,
  Typography,
  Pagination,
} from "@mui/material";
import ordersData from "../../Data/latestorders.json"; 

const LatestOrders = () => {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState({ category: "", date: "", status: "" });

  useEffect(() => {
    setOrders(ordersData); 
  }, []);

  const handleFilterChange = (key, value) => {
    setFilter({ ...filter, [key]: value });
  };

  return (
    <Card sx={{ margin: "20px", padding: "10px", borderRadius: "10px" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Latest Orders
        </Typography>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          flexWrap="wrap"
        >
          <Box sx={{ flex: 1, maxWidth: "350px", mb: { xs: 2, md: 0 } }}>
            <Select
              value={filter.category}
              onChange={(e) => handleFilterChange("category", e.target.value)}
              displayEmpty
              variant="outlined"
              fullWidth
              sx={{ backgroundColor: "#f8f9fa" }}
            >
              <MenuItem value="">All Categories</MenuItem>
              <MenuItem value="category1">Category 1</MenuItem>
              <MenuItem value="category2">Category 2</MenuItem>
            </Select>
          </Box>

          <Box display="flex" gap={2}>
            <TextField
              type="date"
              value={filter.date}
              onChange={(e) => handleFilterChange("date", e.target.value)}
              variant="outlined"
              sx={{ width: "250px", backgroundColor: "#f8f9fa" }}
            />
            <Select
              value={filter.status}
              onChange={(e) => handleFilterChange("status", e.target.value)}
              displayEmpty
              variant="outlined"
              sx={{
                width: "250px",
                backgroundColor: "#f8f9fa",
              }}
            >
              <MenuItem value="">Status</MenuItem>
              <MenuItem value="Paid">Paid</MenuItem>
              <MenuItem value="Refund">Refund</MenuItem>
              <MenuItem value="Chargeback">Chargeback</MenuItem>
            </Select>
          </Box>
        </Box>

        <TableContainer sx={{ overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox />
                </TableCell>
                <TableCell>Order ID</TableCell>
                <TableCell>Billing Name</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Payment Status</TableCell>
                <TableCell>Payment Method</TableCell>
                <TableCell>View Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((order, index) => (
                <TableRow key={index}>
                  <TableCell padding="checkbox">
                    <Checkbox />
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      sx={{ color: "#3bb77e", fontWeight: "bold" }}
                    >
                      #{order.id}
                    </Typography>
                  </TableCell>
                  <TableCell>{order.name}</TableCell>
                  <TableCell>{order.date}</TableCell>
                  <TableCell>{order.total}</TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      sx={{
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color:
                          order.status === "Paid"
                            ? "#3bb77e"
                            : order.status === "Refund"
                            ? "orange"
                            : "red",
                        backgroundColor:
                          order.status === "Paid"
                            ? "rgba(0, 128, 0, 0.1)"
                            : order.status === "Refund"
                            ? "rgba(255, 165, 0, 0.1)"
                            : "rgba(255, 0, 0, 0.1)",
                        fontWeight: "bold",
                        padding: "4px 12px",
                        borderRadius: "20px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {order.status}
                    </Typography>
                  </TableCell>
                  <TableCell>{order.method}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ backgroundColor: "#3bb77e", color: "#fff" }}
                    >
                      View details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box display="flex" justifyContent="flex-start" alignItems="center" mt={2}>
          <Typography variant="body2">01</Typography>
          <Pagination
            count={16}
            sx={{
              "& .MuiPaginationItem-root": {
                backgroundColor: "transparent",
                borderRadius: 0,
                color: "black",
                "&:hover": {
                  backgroundColor: "transparent",
                },
                "&.Mui-selected": {
                  backgroundColor: "#3bb77e",
                  color: "#fff",
                },
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default LatestOrders;
